import React from 'react';
import Button from '../components/Button';
import Section from '../components/Section';
import ColumnSection from '../components/ColumnSection';
import Carousel from '../components/Carousel';
import Clients from '../components/Clients';
import AboutMembers from '../components/AboutMembers';
import Helmet from '../components/Helmet';

import img from './nasi-ludzie.jpg'
import about from './onas.jpg'

import carousel1 from '../images/carousel/1.jpg';
import carousel2 from '../images/carousel/2.jpg';
import carousel3 from '../images/carousel/3.jpg';
import carousel4 from '../images/carousel/4.jpg';
import carousel5 from '../images/carousel/5.jpg';

const images = [
  { resolutions: { src: carousel1 }},
  { resolutions: { src: carousel2 }},
  { resolutions: { src: carousel3 }},
  { resolutions: { src: carousel4 }},
]

const seo = 'CustomArt to agencja artystyczna wyspecjalizowana w projektach nietypowych, ambitnych i takich, w których potrzeba niestandardowych rozwiązań na najwyższym poziomie.'

const subtitle = "<p><strong>CustomArt to agencja artystyczna </strong>wyspecjalizowana w projektach nietypowych, ambitnych i takich, w których potrzeba niestandardowych rozwiązań na najwyższym poziomie.</p>"

const About = (props) => {
  const clients = props.data.allContentfulClientList.edges[0].node.clients;

  return (
    <div className="app-about">
      <Helmet title="O nas">
        <meta name="description" content={seo} />
      </Helmet>
      <Section
        isFirstSection
        title="O NAS"
        background={img}
        subtitle={subtitle}
      />
      <ColumnSection />
      <Section title="NASI LUDZIE" background={about}>
        <div className="section__container" style={{ padding: '100px 0' }}>
          <AboutMembers />
        </div>
      </Section>
      <Carousel images={images} />
      <section className="text-section" style={{ padding: '100px 15px' }}>
        <h2 className="text-section__title" style={{textAlign: 'center'}}>Zuafali nam</h2>
        <Clients clients={clients} />
      </section>
      <div style={{ textAlign: 'center', padding: '30px 0' }}>
        <Button type="yellow" label="Napisz do nas!" mailto="mailto:kontakt@customart.pl"/>
      </div>
      <div style={{paddingTop: 100}} />
    </div>
  )
};

export default About;

export const query = graphql`
  query AboutQuery {
    allContentfulClientList {
      edges {
        node {
          clients {
            name
            logo {
              resolutions(width: 300, quality: 20) {
                src
              }
            }
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/o-nas.js